import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOldJoystick: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconOldJoystick"><Path d="M12 3C13.933 3 15.5 4.567 15.5 6.5C15.5 8.2632 14.1961 9.72121 12.5 9.96387V15H17V12.5C17 12.2239 17.2239 12 17.5 12C17.7761 12 18 12.2239 18 12.5V15H18.5C19.8807 15 21 16.1193 21 17.5V18.5C21 19.8807 19.8807 21 18.5 21H5.5C4.11929 21 3 19.8807 3 18.5V17.5C3 16.1193 4.11929 15 5.5 15H11.5V9.96387C9.8039 9.72121 8.5 8.2632 8.5 6.5C8.5 4.567 10.067 3 12 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOldJoystick;
